<svg xmlns="http://www.w3.org/2000/svg"
     width="64px" height="64px" stroke-linejoin="round"
     viewBox="0 0 64 64">
  <g fill="none" stroke="#000000" stroke-width="4">
  <path class="D12"
        d="M 2.00,22.00
           C 2.00,22.00 14.00,7.00 14.00,7.00
             14.00,7.00 32.00,1.00 32.00,1.00
             32.00,1.00 50.00,7.00 50.00,7.00
             50.00,7.00 62.00,22.00 62.00,22.00
             62.00,22.00 62.00,42.00 62.00,42.00
             62.00,42.00 50.00,57.00 50.00,57.00
             50.00,57.00 32.00,63.00 32.00,63.00
             32.00,63.00 14.00,57.00 14.00,57.00
             14.00,57.00 2.00,42.00 2.00,42.00
             2.00,42.00 2.00,22.00 2.00,22.00 Z
           M 32.00,14.00
           C 32.00,14.00 49.00,26.00 49.00,26.00
             49.00,26.00 42.00,45.00 42.00,45.00
             42.00,45.00 22.00,45.00 22.00,45.00
             22.00,45.00 15.00,26.00 15.00,26.00
             15.00,26.00 32.00,14.00 32.00,14.00 Z
           M 32.00,14.00
           C 32.00,14.00 32.00,1.00 32.00,1.00M 49.00,26.00
           C 49.00,26.00 62.00,22.00 62.00,22.00M 42.00,45.00
           C 42.00,45.00 50.00,57.00 50.00,57.00M 22.00,45.00
           C 22.00,45.00 14.00,57.00 14.00,57.00M 15.00,26.00
           C 15.00,26.00 2.00,22.00 2.00,22.00" />
   </g>
</svg>
